module.exports = __webpack_public_path__ + "fc6933ef77bbe73200963072d8729ec1.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/orks-preview.webm
// module id = 640
// module chunks = 0